// extracted by mini-css-extract-plugin
module.exports = {"addFeed":"styles_addFeed__3mBrn","container":"styles_container__2uB3r"};